// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/switch/Disabled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Switch, view } from '@sail/ui';
export const Disabled = () => {
  const [checked, setChecked] = React.useState(false);
  return <view.div css={{
    layout: 'column',
    gap: 'medium'
  }}>
      <Switch label="This uncontrolled Switch is disabled." defaultChecked disabled />
      <Switch onChange={() => {
      setChecked(!checked);
    }} checked={checked} disabled label="This controlled Switch is disabled." />
    </view.div>;
};